import { render, staticRenderFns } from "./hotSpot.vue?vue&type=template&id=6bb9a858&scoped=true"
import script from "./hotSpot.vue?vue&type=script&lang=js"
export * from "./hotSpot.vue?vue&type=script&lang=js"
import style0 from "./hotSpot.vue?vue&type=style&index=0&id=6bb9a858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb9a858",
  null
  
)

export default component.exports